<template>
	<div class="assessment_details">
    <div class="mb-4" v-if="entityActivity && myattempts.length > 0">
      <div>Attempt #{{myattempts.length}}: Time spent on this Knowledge Check</div>
      <!--<div><strong>{{msToTime(entityActivity.assessmentTimeTaken)}}</strong></div>-->
    </div>
    <div class="attempt_summary_info" v-if="assessment.maxAttempt > 1">
      Attempt <span class="val">{{attemptsRemaining}}</span> of <span class="val">{{assessment.maxAttempt}}</span>
    </div>
    <div class="row" style="background: #e6e6e6; min-height: 40px; align-items: center;" v-if="myattempts.length > 0">
      <h5 style="margin: 5px;">Attempts Summary</h5>
    </div>
    <div :class="{row: (myattempts.length > 0)}" :style="{'background': ((myattempts.length > 0) ? '#ffffff' : ''), 'min-height': ((myattempts.length > 0) ? '45px' : '')}">
      <template v-if="showAssessmentDetailPage">
        <template v-if="isStudentLogin">
          <div v-if="myattempts.length > 0" class="container-fluid">
            <div class="row mt-2" v-for="(myattempt, index) in myattempts">
              <div class="col-1">#{{index + 1}}</div>
              <div class="col-6">{{getFormattedDateTime(myattempt.startTime)}}</div>
              <div class="col-2">
                <div v-if="!myattempt.manualGradingRequired || (myattempt.manualGradingRequired && myattempt.manuallyGraded)">
                  <span :id="'stat_' + index"></span> {{myattempt.score}}/{{myattempt.maxScore}}
                </div>
                <div v-else>
                  <span :id="'stat_' + index"></span> {{myattempt.score}}/{{myattempt.maxScore}}
                </div>
              </div>
              <div class="col-3">
                <div v-if="myattempt.isResume && ((!myattempt.manualGradingRequired) || (myattempt.manualGradingRequired && myattempt.manuallyGraded))">
                  <b-link variant="primary" :to="{name: 'assessmentLearn', params: {uuid: uuid, entityUuid: entityUuid, entityType: entityType, sessionId: assessment.sessionId}}">Resume</b-link>
                </div>
                <div v-else>
                  <template v-if="!myattempt.manualGradingRequired || (myattempt.manualGradingRequired && myattempt.manuallyGraded)">
										<b-link class="report_link" variant="primary" @click="showLearnosityReport(myattempt)">
											<span class="ic ic-reports"></span>
										</b-link>
                    <b-link class="report_link" variant="primary" @click="showAttemptAI(myattempt, myattempt.activityId, myattempt.sessionId)" v-if="isAIAnswerAnalysisEnabled">
                      <span class="ic ic24-ai"></span>
                    </b-link>
                    <b-link class="report_link breakdown_report_link" variant="primary" v-if="(assessment.diagonesticTest || assessment.diagonesticReportTest) && (!myattempt.manualGradingRequired || (myattempt.manualGradingRequired && myattempt.manuallyGraded))" @click="showDiagnosticTestReport">Competency Breakdown Report</b-link>
                  </template>
                  <template v-else>
                    <span>Grade Pending</span>
                  </template>
                </div>
              </div>
            </div>
            <div v-if="isShowCheckKnowledgeButton" style="margin-top: 22px;">
              <b-button variant="primary" v-if="!assessment.isResume" :to="{name: 'assessmentLearn', params: {uuid: uuid, entityUuid: entityUuid, entityType: entityType, sessionId: assessment.sessionId}}" class="btn btn-md">Check Your Knowledge</b-button>
            </div>
          </div>
          <div v-if="isShowCheckKnowledgeButton && myattempts.length === 0">
            <div v-if="!assessment.isResume && isDescriptionReady" style="text-align: justify;">
              <template v-if="assessment.localPractice || assessment.diagonesticReportTest || assessment.diagonesticTest ">
                <template v-if="institution.overrideAssessmentDescription">
                  <span v-html="configuredDesc"></span>
                </template>
                <template v-else>
                  <template v-if="assessment.description">
                    <span v-html="assessment.description"></span>
                  </template>
                  <template v-else>
                    <span v-html="configuredDesc"></span>
                  </template>
                </template>
              </template>
              <template v-else>
                <template v-if="institution.overrideAssessmentDescription">
                  <span v-html="configuredCnowledgeCheckDescription"></span>
                </template>
                <template v-else>
                  <template v-if="assessment.description">
                    <span v-html="assessment.description"></span>
                  </template>
                  <template v-else>
                    <span v-html="configuredCnowledgeCheckDescription"></span>
                  </template>
                </template>
              </template>
            </div>
            <div class="btn_container">
              <template v-if="!assessment.diagonesticReportTest && !assessment.diagonesticTest && !assessment.localPractice">
                <b-button variant="primary" v-if="!assessment.isResume" :to="{name: 'assessmentLearn', params: {uuid: uuid, entityUuid: entityUuid, entityType: entityType, sessionId: assessment.sessionId}}" class="btn btn-md">Check Your Knowledge</b-button>
                <b-button variant="primary" v-else :to="{name: 'assessmentLearn', params: {uuid: uuid, entityUuid: entityUuid, entityType: entityType, sessionId: assessment.sessionId}}" class="btn btn-md">Resume Knowledge Check</b-button>
              </template>
              <template v-if="assessment.diagonesticTest">
                <b-button variant="primary" v-if="!assessment.isResume" :to="{name: 'assessmentLearn', params: {uuid: uuid, entityUuid: entityUuid, entityType: entityType, sessionId: assessment.sessionId}}" class="btn btn-md">Start Pre-Diagnostic</b-button>
                <b-button variant="primary" v-else :to="{name: 'assessmentLearn', params: {uuid: uuid, entityUuid: entityUuid, entityType: entityType, sessionId: assessment.sessionId}}" class="btn btn-md">Resume Pre-Diagnostic</b-button>
              </template>
              <template v-if="assessment.diagonesticReportTest">
                <b-button variant="primary" v-if="!assessment.isResume" :to="{name: 'assessmentLearn', params: {uuid: uuid, entityUuid: entityUuid, entityType: entityType, sessionId: assessment.sessionId}}" class="btn btn-md">Start Post-Diagnostic</b-button>
                <b-button variant="primary" v-else :to="{name: 'assessmentLearn', params: {uuid: uuid, entityUuid: entityUuid, entityType: entityType, sessionId: assessment.sessionId}}" class="btn btn-md">Resume Post-Diagnostic</b-button>
              </template>
              <template v-if="assessment.localPractice">
                <b-button variant="primary" v-if="!assessment.isResume" :to="{name: 'assessmentLearn', params: {uuid: uuid, entityUuid: entityUuid, entityType: entityType, sessionId: assessment.sessionId}}" class="btn btn-md">Start Practice Test</b-button>
                <b-button variant="primary" v-else :to="{name: 'assessmentLearn', params: {uuid: uuid, entityUuid: entityUuid, entityType: entityType, sessionId: assessment.sessionId}}" class="btn btn-md">Resume Practice Test</b-button>
              </template>
            </div>
          </div>
        </template>
        <template v-else>
          <b-button variant="primary" :to="{name: 'assessmentLearn', params: {uuid: uuid, entityUuid: entityUuid, entityType: entityType, sessionId: assessment.sessionId}}" class="btn btn-md">Preview Knowledge Check</b-button>
        </template>
      </template>
    </div>
        <b-modal id="aiAttemptModalContainer" class="full_screen_modal modal__v22_2" ref="aiAttemptModal"  size="" hide-footer no-close-on-backdrop no-close-on-esc>
          <div slot="modal-header" class="row header-section">
            <div class="col-1 hd_ic">
              <span class="ic ic24-ai"></span>
            </div>
            <div class="col-10 hd_txt">
              {{aiResorce.title}}
            </div>
            <div class="col-1 close_btn_container pr-0">
              <button class="btn_close" aria-label="close" @click="closeaiAttemptModal">
                <span class="ic-close"></span>
              </button>
            </div>
          </div>
          <div class="rich-html-container-parent" style="text-align: left;">
            <div v-if="!aiResorce.htmlBody">
							Pragya AI is analyzing your answers. It will only take a few seconds. Please wait...
							<stretch></stretch>
            </div>
          </div>

          <div class="rich-html-container-parent" style="text-align: left;">
            <div v-html="aiResorce.htmlBody">
            </div>
          </div>

        </b-modal>
    <b-modal id="diagnosticReportModal" ref="diagnosticTestReportInfo" size="lg" centered  @hidden="isShowDiagnosticTestReport = false" hide-footer class="learnosity-report-modal diagnostic_report_modal">
      <template v-if="isShowDiagnosticTestReport">
        <div slot="modal-header" class="header-section">
					<div class="float-left">
						{{diagnosticTestReport.userName}} - Diagnostic Test Results - Attempt on {{diagnosticTestReport.testDate}}
					</div>
          <div class="float-right">
            <button type="button" aria-label="Close" class="attempt-report-close" @click="closeDiagnosticTestReport">x</button>
            <button type="button" aria-label="Print" class="attempt-report-close" @click="printDiagnosticTestReport">print</button>
          </div>
				</div>
        <div class="popup_inner_content">
          <div class="course_name">
            {{diagnosticTestReport.course}}
          </div>
          <table class="table report_table">
						<!--
            <thead>
              <tr>
                <th>Topic</th>
                <th>Score</th>
                <th>Performance</th>
                <th>Status</th>
              </tr>
            </thead>
						-->
            <tbody>
							<tr>
								<td>
		              <div class="row topic_row" v-for="module in diagnosticTestReport.modules">
		                <div class="col-12 tbl_col_1">
											<span class="label">Topic:</span>
											<span>{{module.competencyName}}</span>
										</div>
		                <div class="col-12 tbl_col_2">
											<span class="label">Score: </span>
		                  <template v-if="module.performance >= 90">
		                    <div class="sec_txt_score gradeA">
		                      <span class="txt">{{module.correct}}/{{module.max}}</span>
		                      <span class="ic ic24-flower1"></span>
		                    </div>
		                  </template>
		                  <template v-if="module.performance >= 80 && module.performance < 90">
		                    <div class="sec_txt_score gradeB">
		                      <span class="txt">{{module.correct}}/{{module.max}}</span>
		                      <span class="ic ic24-flower1"></span>
		                    </div>
		                  </template>
		                  <template v-if="module.performance >= 65 && module.performance < 80">
		                    <div class="sec_txt_score gradeC">
		                      <span class="txt">{{module.correct}}/{{module.max}}</span>
		                      <span class="ic ic24-flower1"></span>
		                    </div>
		                  </template>
		                  <template v-if="module.performance >= 40 && module.performance < 65">
		                    <div class="sec_txt_score gradeD">
		                      <span class="txt">{{module.correct}}/{{module.max}}</span>
		                      <span class="ic ic24-flower1"></span>
		                    </div>
		                  </template>
		                  <template v-if="module.performance < 40">
		                    <div class="sec_txt_score gradeE">
		                      <span class="txt">{{module.correct}}/{{module.max}}</span>
		                      <span class="ic ic24-flower1"></span>
		                    </div>
		                  </template>
		                </div>
		                <div class="col-12 tbl_col_3">
											<span class="label">Performance: </span>
		                  <template v-if="module.performance >= 90">
		                    <div class="performance_bx gradeA">{{module.performance}}%</div>
		                  </template>
		                  <template v-if="module.performance >= 80 && module.performance < 90">
		                    <div class="performance_bx gradeB">{{module.performance}}%</div>
		                  </template>
		                  <template v-if="module.performance >= 65 && module.performance < 80">
		                    <div class="performance_bx gradeC">{{module.performance}}%</div>
		                  </template>
		                  <template v-if="module.performance >= 40 && module.performance < 65">
		                    <div class="performance_bx gradeD">{{module.performance}}%</div>
		                  </template>
		                  <template v-if="module.performance < 40">
		                    <div class="performance_bx gradeE">{{module.performance}}%</div>
		                  </template>
		                </div>
		                <div class="col-12 tbl_col_4">
											<span class="label">Status: </span>
											<span> {{module.status}} </span>
										</div>
									</div>
								</td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>
      <template v-if="!isShowDiagnosticTestReport">
        Loading..
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { DateTime } from 'luxon'
import Navbar from '../../misc/components/./Navbar'

export default {
  name: 'assessment-detail',
  props: ['uuid', 'entityUuid', 'entityType'],
  components: {
    Navbar
  },
  data: () => {
    return {
      attempt: {},
      myattempts: [],
      assessment: {},
      aiResorce : {},
      isDescriptionReady: false,
      showAssessmentDetailPage: false,
      entityActivity: null,
      isTransitionPage: false,
      configuredCnowledgeCheckDescription: '',
      diagnosticTestReport: {},
      isShowDiagnosticTestReport: false
    }
  },

  mounted () {
    this.loadDetail()
  },

  methods: {
    ...mapActions([
      'loadAssessment2',
      'loadEntityActivity',
      'showAttemptAIReport',
      'loadKCDescription',
      'loadDiagnosticTestReport',
      'loadAIResource'
    ]),

    async loadDetail () {
      this.isTransitionPage = (this.$route.name === 'entityResult')
      this.configuredCnowledgeCheckDescription = await this.loadKCDescription({entityId: this.entityUuid, courseType: this.course.courseType, courseId: this.course.uuid})
        if (this.configuredCnowledgeCheckDescription === '') {
          this.configuredCnowledgeCheckDescription = this.institution.knowledgeCheckDescription.replace('KC_TITLE', this.assessment.ancestorName)
        }
      this.loadAssessment2(this.entityUuid).then(res => {
        const data = { ...res }
        this.myattempts = data.attempt
        if (this.myattempts && this.myattempts.length > 0) {
          this.attempt = this.myattempts[this.myattempts.length - 1]
        }
        this.assessment = data.assessment
        this.isDescriptionReady = true
        this.showAssessmentDetailPage = true
        if (this.isTransitionPage) {
          var entityActityInfo = {
            'courseUuid': this.uuid,
            'entityType': this.entityType,
            'entityUuid': this.entityUuid
          }
          this.loadEntityActivity(entityActityInfo).then(res => {
            if (res) {
              this.entityActivity = res
            }
          })
        }
      })
    },

    getFormattedDateTime (millis) {
      let formattedDate = DateTime.fromMillis(millis).toFormat('LLL dd, yyyy hh:mm a')
      return formattedDate
    },

    showLearnosityReport (attempt) {
      let activityId = attempt.activityId
      let sessionId = attempt.sessionId
      return this.$router.push({name: 'assessmentReport', params: {uuid: this.uuid, entityUuid: this.entityUuid, attempt: attempt, activityId: activityId, sessionId: sessionId, isTransitionPage: this.isTransitionPage}})
    },

    msToTime (s) {
      if (s === undefined) {
        return '00 hrs : 00 mins : 00 seconds'
      }
      var ms = s % 1000
      s = (s - ms) / 1000
      var secs = s % 60
      s = (s - secs) / 60
      var mins = s % 60
      if (mins < 10) {
        mins = '0' + mins
      }
      var hrs = (s - mins) / 60
      if (hrs < 10) {
        hrs = '0' + hrs
      }
      return hrs + ' hrs : ' + mins + ' mins : ' + secs + ' seconds'
    },
    async showDiagnosticTestReport () {
      this.$refs.diagnosticTestReportInfo.show()
      this.diagnosticTestReport = await this.loadDiagnosticTestReport({courseId: this.course.uuid, assessmentId: this.assessment.uuid })
      this.isShowDiagnosticTestReport = true
    },
    printDiagnosticTestReport () {
      const modal = document.getElementById("diagnosticReportModal")
      const cloned = modal.cloneNode(true)
      let section = document.getElementById("print")

      if (!section) {
         section  = document.createElement("div")
         section.id = "print"
         document.body.appendChild(section)
      }

      section.innerHTML = "";
      section.appendChild(cloned);
      window.print();

      setTimeout(function () {
          document.body.removeChild(section);
      }, 500)
    },
    openaiAttemptModal (resourceId, ref) {
    if(ref){
      var entityDetailInfo = {
        'entityUuid': resourceId,
        'entityType': 'LearningContent'
      }
      this.loadAIResource(entityDetailInfo).then(res => {
        this.aiResorce = res
        ref.show()
      })
     }
    },
    closeaiAttemptModal () {
      this.$refs.aiAttemptModal.hide()
    },
    showAttemptAI (myattempt, activityId, sessionId, isManuallyGraded) {
      this.$refs.aiAttemptModal.show()
      this.showAttemptAIReport({activityId: activityId, sessionId: sessionId, courseId: this.course.uuid}).then(data => {
        if (data) {
          this.openaiAttemptModal(data, this.$refs.aiAttemptModal)
        }
      })

    },

    closeDiagnosticTestReport () {
      this.$refs.diagnosticTestReportInfo.hide()
    }
  },

  computed: {
    ...mapState({
      'userObj': state => state.login.userObj,
      'enabledFeatures': state => state.dashboard.enabledFeatures,
      'course': state => state.dashboard.course,
      'institution': state => state.dashboard.institution
    }),
    isAIAnswerAnalysisEnabled (){
      let contentToolsFeature = this.enabledFeatures['KC Tools']
      if (contentToolsFeature) {
        let flags = contentToolsFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'KC Learner Answer Analysis') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    attemptsRemaining: function () {
      if (this.assessment && this.myattempts) {
        return this.assessment.maxAttempt - this.myattempts.length
      }
      return 0
    },

    isShowCheckKnowledgeButton: function () {
      return this.isStudentLogin && this.assessment.isAttemptRemaining
    },

    isStudentLogin () {
      let role = this.userObj.roles[0].role
      return (role === 'Student')
    },
    configuredDesc () {
        var configDesc = ''
        if(this.assessment.localPractice){
          configDesc =  this.institution.praticeTestDesc.replace('KC_TITLE', this.assessment.ancestorName)
        }
        if(this.assessment.diagonesticTest){
          configDesc =  this.institution.preDiagnosticTestDesc.replace('KC_TITLE', this.assessment.ancestorName)
        }
        if(this.assessment.diagonesticReportTest){
          configDesc =  this.institution.postDiagnosticTestDesc.replace('KC_TITLE', this.assessment.ancestorName)
        }
        return configDesc?configDesc:this.institution.knowledgeCheckDescription.replace('KC_TITLE', this.assessment.ancestorName)
      },
    showDescription: function () {
      if (this.course.courseType.startsWith('SUGGESTION')) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/assessment/components/AssessmentDetail.vue